(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gy2-media-text"] && !Shopify.designMode) return;
  try {
    
  if (!window.__gy2Modal) {
    window.__gy2Modal = true;
    document.addEventListener('click', function (e) {
      var open = e.target.closest && e.target.closest('[data-gy2-open]');
      if (open) {
        var dlg = document.getElementById(open.getAttribute('data-gy2-open'));
        if (dlg && typeof dlg.showModal === 'function') { e.preventDefault(); dlg.showModal(); }
        else if (dlg) { dlg.setAttribute('open', ''); }
        return;
      }
      var close = e.target.closest && e.target.closest('[data-gy2-close]');
      if (close) { var d = close.closest('dialog'); if (d) { d.close ? d.close() : d.removeAttribute('open'); } return; }
      if (e.target && e.target.tagName === 'DIALOG' && e.target.classList.contains('gy2-modal')) {
        e.target.close ? e.target.close() : e.target.removeAttribute('open');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gy2-nonenal"] && !Shopify.designMode) return;
  try {
    
  // Ouverture et fermeture de la popup de recherche. Délégation sur document et garde
  // globale : l'éditeur de thème réinjecte la section à chaque changement de réglage.
  if (!window.__gy2Modal) {
    window.__gy2Modal = true;
    document.addEventListener('click', function (e) {
      var open = e.target.closest && e.target.closest('[data-gy2-open]');
      if (open) {
        var dlg = document.getElementById(open.getAttribute('data-gy2-open'));
        if (dlg && typeof dlg.showModal === 'function') { e.preventDefault(); dlg.showModal(); }
        else if (dlg) { dlg.setAttribute('open', ''); }
        return;
      }
      var close = e.target.closest && e.target.closest('[data-gy2-close]');
      if (close) {
        var d = close.closest('dialog');
        if (d) { d.close ? d.close() : d.removeAttribute('open'); }
        return;
      }
      // Un clic sur le fond ferme : la cible du clic est alors le <dialog> lui-même,
      // jamais le panneau, qui couvre toute la surface intérieure.
      if (e.target && e.target.tagName === 'DIALOG' && e.target.classList.contains('gy2-modal')) {
        e.target.close ? e.target.close() : e.target.removeAttribute('open');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gyrah-ony-product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__gyrahOny) { window.__gyrahOny(); return; }

    function gallery(root) {
      (root || document).querySelectorAll('[data-ony-gallery]').forEach(function (gal) {
        if (gal.getAttribute('data-ready') === '1') return;
        var track = gal.querySelector('.ony-gal__track');
        var dots = gal.querySelector('[data-ony-dots]');
        var slides = track ? [].slice.call(track.children) : [];
        if (slides.length < 2) { if (dots) dots.style.display = 'none'; gal.setAttribute('data-ready', '1'); return; }
        dots.innerHTML = '';
        slides.forEach(function (s, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = i === 0 ? 'is-active' : '';
          b.setAttribute('aria-label', 'Image ' + (i + 1));
          b.addEventListener('click', function () {
            var to = s.offsetLeft - track.offsetLeft;
            var from = track.scrollLeft;
            track.scrollTo({ left: to, behavior: 'smooth' });
            /* Smooth scrolling is inert in some embedded viewers; jump instead. */
            setTimeout(function () { if (Math.abs(track.scrollLeft - from) < 2) track.scrollLeft = to; }, 320);
          });
          dots.appendChild(b);
        });
        var pending = null;
        track.addEventListener('scroll', function () {
          if (pending) return;
          pending = setTimeout(function () {
            pending = null;
            var mid = track.scrollLeft + track.clientWidth / 2, best = 0, bd = Infinity;
            slides.forEach(function (s, i) {
              var c = s.offsetLeft - track.offsetLeft + s.offsetWidth / 2;
              var d = Math.abs(c - mid);
              if (d < bd) { bd = d; best = i; }
            });
            [].forEach.call(dots.children, function (b, i) { b.classList.toggle('is-active', i === best); });
          }, 90);
        }, { passive: true });
        gal.setAttribute('data-ready', '1');
      });
    }

    function reviews(root) {
      (root || document).querySelectorAll('[data-ony-reviews]').forEach(function (slider) {
        if (slider.getAttribute('data-ready') === '1') return;
        slider.setAttribute('data-ready', '1');
        var track = slider.querySelector('.onypets-review-slider__track');
        var slides = slider.querySelectorAll('.onypets-review-slide');
        var dots = slider.querySelectorAll('.onypets-review-slider__dot');
        var prev = slider.querySelector('.onypets-review-slider__arrow--prev');
        var next = slider.querySelector('.onypets-review-slider__arrow--next');
        if (!track || !slides.length) return;
        var i = 0;
        function update() {
          track.style.transform = 'translateX(-' + (i * 100) + '%)';
          [].forEach.call(dots, function (d, k) { d.classList.toggle('is-active', k === i); });
          [].forEach.call(slides, function (s, k) { s.classList.toggle('is-active', k === i); });
        }
        function go(n) { i = (n + slides.length) % slides.length; update(); }
        if (next) next.addEventListener('click', function () { go(i + 1); });
        if (prev) prev.addEventListener('click', function () { go(i - 1); });
        [].forEach.call(dots, function (d, k) { d.addEventListener('click', function () { go(k); }); });
        var sx = 0;
        slider.addEventListener('touchstart', function (e) { sx = e.changedTouches[0].screenX; }, { passive: true });
        slider.addEventListener('touchend', function (e) {
          var diff = sx - e.changedTouches[0].screenX;
          if (Math.abs(diff) > 40) go(diff > 0 ? i + 1 : i - 1);
        }, { passive: true });
        var mx = 0, dragging = false;
        track.addEventListener('mousedown', function (e) { mx = e.clientX; dragging = true; track.style.cursor = 'grabbing'; });
        window.addEventListener('mouseup', function (e) {
          if (!dragging) return;
          dragging = false;
          track.style.cursor = 'grab';
          var diff = mx - e.clientX;
          if (Math.abs(diff) > 40) go(diff > 0 ? i + 1 : i - 1);
        });
        track.style.cursor = 'grab';
        update();
      });
    }

    /* One delegated handler for every "Read more", so re-injected sections keep working. */
    if (!window.__gyrahOnyMore) {
      window.__gyrahOnyMore = true;
      document.addEventListener('click', function (e) {
        var btn = e.target.closest && e.target.closest('.onypets-review-card__more');
        if (!btn) return;
        e.preventDefault();
        var card = btn.closest('.onypets-review-card');
        var open = card.classList.toggle('is-expanded');
        btn.textContent = open ? (btn.getAttribute('data-less') || 'Show less') : (btn.getAttribute('data-more') || 'Read more');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    function init(root) { gallery(root); reviews(root); }
    window.__gyrahOny = init;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
    else init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gyrah-video-row"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__gyrLoop) return;
    window.__gyrLoop = true;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var video = entry.target;
          if (entry.isIntersecting) {
            if (video.preload === 'none') video.preload = 'auto';
            var play = video.play();
            if (play && play.catch) play.catch(function () {});
          } else {
            video.pause();
          }
        });
      },
      { rootMargin: '200px 0px' }
    );

    function observe() {
      document.querySelectorAll('video[data-gyr-loop]').forEach(function (video) {
        if (video.dataset.gyrObserved) return;
        video.dataset.gyrObserved = '1';
        video.muted = true;
        observer.observe(video);
      });
    }

    observe();
    document.addEventListener('shopify:section:load', observe);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pa-reviews"] && !Shopify.designMode) return;
  try {
    
  class PaReviewsTrack extends HTMLElement {
    connectedCallback() {
      // Desktop slider starts centered on the middle card so partial cards
      // peek on BOTH sides (infinite-strip look). Grid mode and mobile keep
      // their natural start position.
      if (this.classList.contains('pa-reviews__track--grid')) return;
      if (!window.matchMedia('(min-width: 750px)').matches) return;

      requestAnimationFrame(() => {
        const cards = this.children;
        if (cards.length < 2) return;
        const mid = cards[Math.floor(cards.length / 2)];
        if (!mid) return;
        const left = mid.offsetLeft - (this.clientWidth - mid.clientWidth) / 2;
        this.scrollLeft = Math.max(0, left);
      });
    }
  }

  if (!customElements.get('pa-reviews-track')) {
    customElements.define('pa-reviews-track', PaReviewsTrack);
  }

  } catch(e) { console.error(e); }
})();
})();
